//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import _ from 'lodash';
import SimpleBar from 'simplebar';
import ClickOutside from '@/directives/ClickOutside';
import { naturalSort } from '@/helpers/util';
import Emitter from '@/mixins/emitter';
import Tooltip from '@/mixins/tooltip';
import DpDropdown from '../dropdown/Dropdown.vue';
import DpIcon from '../icon/Icon.vue';
import DpInput from '../input/Input.vue';
import DpSpinnerLoader from '../loader/SpinnerLoader.vue';

export default {
  name: 'DpMultiSelect',
  directives: {
    ClickOutside,
  },
  components: {
    DpIcon,
    DpInput,
    DpSpinnerLoader,
    DpDropdown,
  },
  mixins: [Emitter, Tooltip],
  props: {
    value: { type: Array, default: null },
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    placeholder: { type: String, default: '' },
    size: { type: String, default: 'default' },
    clearable: { type: Boolean, default: false },
    fullWidth: { type: Boolean, default: false },
    filterable: { type: Boolean, default: false },
    minWidth: { type: Number, default: 100 },
    options: { type: Array, default: () => [] },
  },
  data() {
    return {
      open: false,
      focus: false,
      query: '',
      focusedFilterInput: false,
      inputElement: null,
      scrollArea: null,
      selectAll: false,
      internalModel: [],
    };
  },
  computed: {
    isFocus() {
      return this.open || this.focus;
    },
    currentSelectionText() {
      const selectedItems = this.internalModel.length;
      if (selectedItems === 1) {
        return this.internalModel[0];
      }
      if (selectedItems > 1) {
        return `${this.placeholder} (${selectedItems})`;
      }
      return this.placeholder;
    },
    placeholderText() {
      if (!this.$t) return 'blah';
      if (this.loading) {
        return this.$t('ui.loadingOptions');
      }
      if (this.placeholder) {
        return this.placeholder;
      }
      return this.$t('ui.chooseOption');
    },
    isPlaceholder() {
      return this.internalModel.length === 0;
    },
    inputTabindex() {
      return this.open ? 0 : -1;
    },
    topOffset() {
      // The height of the "current" box and the border offset
      if (this.size === 'small') {
        return 40;
      }
      if (this.size === 'large') {
        return 60;
      }
      return 50;
    },
    shownOptions() {
      const query = this.query.toLowerCase();
      const filteredOptions = this.options.filter((o) => {
        const label = o.label.toLowerCase();
        const value = o.value.toLowerCase();
        return label.includes(query) || value.includes(query);
      });
      return naturalSort(filteredOptions, 'label');
    },
    numberOfVisibleOptions() {
      return this.shownOptions.length;
    },
  },
  watch: {
    value(newVal) {
      if (!_.isEqual(newVal, this.internalModel)) {
        this.internalModel = newVal;
      }
    },
  },
  created() {
    this.customScroll = null;
  },
  mounted() {
    // Grab the HTML elements in the select for focusing and scrollTo
    // this.inputElement = this.$el.querySelector('.dp-input input');
    this.mountScrollbar();
  },
  beforeDestroy() {
    if (this.customScroll) {
      this.customScroll.unMount();
      delete this.customScroll;
    }
  },
  methods: {
    mountScrollbar() {
      if (this.customScroll) {
        this.customScroll.unMount();
      }
      const scrollContainer = this.$refs.scrollarea;
      this.scrollArea = scrollContainer;
      this.customScroll = new SimpleBar(scrollContainer, {
        autoHide: true,
      });
    },
    hide() {
      if (!this.open) {
        return;
      }
      this.open = false;
      this.handleBlur();
      this.enableTooltip();
    },
    show() {
      if (this.loading || this.disabled) {
        return;
      }
      this.disableTooltip();

      this.open = true;

      // Mount the scrollbar as soon as the element exists
      setTimeout(() => {
        this.mountScrollbar();
      }, 10);

      // Setting the focus on the filter element appears to require a longer delay, perhaps
      // because of the opening animation
      setTimeout(() => {
        if (this.filterable && this.$refs.filter) {
          this.$refs.filter.focus();
        }
      }, 150);
    },
    toggleSelectAll(selectAll) {
      if (selectAll) {
        const allOptions = this.options.map(({ value }) => value);
        this.internalModel = allOptions;
      } else {
        this.internalModel = [];
      }
      this.emitChange();
    },
    handleBlur() {
      if (!this.open) {
        this.focus = false;
      }
    },
    handleClick() {
      if (!this.open) {
        this.show();
      } else {
        this.hide();
      }
    },
    handleQueryChange() {
      this.$nextTick(() => {
        this.customScroll.recalculate();
      });
    },
    handleButtonClick() {
      this.hide();
    },
    handleClear() {
      this.internalModel = [];
      this.emitChange();
    },
    emitChange() {
      const { internalModel } = this;
      this.$emit('input', internalModel);
      this.$emit('change', internalModel);
    },
  },
};
